import { useContext } from 'react';
import { store } from 'components/Store';
import useCreateParliamentLiveFilters from 'components/Dashboard/ParliamentLive/useCreateParliamentLiveFilters';
import parliamentarianUsers from 'components/Dashboard/SidebarElements/parliamentarianUsers';
import Sections from 'components/Dashboard/SearchControl/Sections';

const useCreateSections = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { activePlan } = state;
  const { code, enableLiveTranscription } = activePlan;

  const { createParliamentLiveFilters } = useCreateParliamentLiveFilters();

  const createSections = () => {
    let resultSections = [];
    if (parliamentarianUsers(code)) {
      let newSections = [...Sections];
      let lobbyingMaterial = newSections.findIndex((item) => item?.name === 'LobbyingMaterial');
      newSections[lobbyingMaterial].urlName = 'campaigns';
      resultSections = newSections;
    } else {
      resultSections = Sections;
    }
    resultSections = [...resultSections.filter((item) => !item.hidden)];

    const parliamentLiveItemPosition = resultSections?.findIndex((item) => item?.name === 'ParliamentLive');
    if (parliamentLiveItemPosition >= 0) {
      if (enableLiveTranscription) {
        const { parliamentLiveFilters } = createParliamentLiveFilters({});
        resultSections[parliamentLiveItemPosition] = {
          ...resultSections[parliamentLiveItemPosition],
          filters: parliamentLiveFilters,
        };
      } else {
        resultSections?.splice(parliamentLiveItemPosition, 1);
      }
    }
    return resultSections;
  };

  return { createSections };
};

export default useCreateSections;
